import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import ConfettiComponent from '../../../../utilities/confetti';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import {Container, Row, Col} from 'reactstrap';
import SuccessImage from '../Assets/ok_Done.svg';
import {getFormatDate} from '../../../../utilities/dateUtils';

const OrderSuccess = (props) => {
  const {saveAs} = require('file-saver');
  const ics = require('ics');
  const deliveryTime = `${props.selectedDeliverySlot.waitFrom.substring(0, 5)}-${props.selectedDeliverySlot.waitTo.substring(0, 5)}`;
  const date = getFormatDate(new Date(props.selectedDeliverySlot.lfdat)).replace('/', '.').replace('/', '.');

  const setCalendar = () => {
    let eventDelivery = [];

    let dateDelivery = new Date(props.selectedDeliverySlot.lfdat);
    eventDelivery = {
      start: [
        dateDelivery.getFullYear(),
        dateDelivery.getMonth() + 1,
        dateDelivery.getDate(),
        parseInt(props.selectedDeliverySlot.waitFrom),
        0,
      ],
      duration: {hours: 2},
      title: `שליחות ${window.Config.brand_Name_HE} `,
      description: `במועד זה יגיע שליח של ${window.Config.brand_Name_HE} לכתובת ${props.fullAddress}`,
      location: '',
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    ics.createEvent(eventDelivery, (error, value) => {
      if (error) {
        return;
      }
      var file = new File([value], 'event.ics', {type: 'text/calendar'});
      saveAs(file);
    });
  };

  return (
    <Container className='orderSuccess'>
      <div className='order-created-successfully'>
        <ConfettiComponent />
        <span className='order-created-successfully__title'>ההזמנה בוצעה בהצלחה</span>
        <Image className='order-created-successfully__image' src={SuccessImage} alt='success image' />
        <span>אז כמו שקבענו</span>
        <span>שליח יגיע אליך לכתובת</span>
        <span className='order-created-successfully__address'>{props.fullAddress}</span>
        <span className='order-created-successfully__date'>{`${deliveryTime}  |  ${date}`}</span>
        <span>שינוי במועד הגעת השליח ניתן לעשות גם</span>
        <span>כן אצלנו באתר באזור האישי</span>
        <div className='order-created-successfully__footer'>
          <div className='order-created-successfully__btn-holder' onClick={() => EpiContext.navigateTo(Config.lobbyUrl)}>
            <Image src={require('../../SaleBlock/OrderSuccess/images/personal-area.svg')} alt='איזור אישי' />
            <span className='order-created-successfully__btn-label'>לאיזור האישי</span>
          </div>
          <div className='order-created-successfully__btn-holder' onClick={() => setCalendar()}>
            <Image src={require('../../SaleBlock/OrderSuccess/images/calendar.svg')} alt='לוח שנה' />
            <span className='order-created-successfully__btn-label'>הוספת תזכורת ליומן</span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OrderSuccess;

